import { render, staticRenderFns } from "./user-delete.view.vue?vue&type=template&id=fc256df8&"
import script from "./user-delete.view.vue?vue&type=script&lang=ts&"
export * from "./user-delete.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports